<template>
  <div class="bg-grey-10 rounded-2xl overflow-hidden">
    <img
      src="../../../public/assets/images/experience/leaders-meeting.png"
      alt="Leaders' Meeting"
      class="w-full aspect-[327/180] object-cover"
    />
    <div class="p-4">
      <h3 class="font-aktiv-grotesk-medium text-[16px] leading-[24px] text-grey-100">
        Leaders' Meeting
      </h3>
      <p class="font-aktiv-grotesk-regular text-[16px] leading-[24px] text-grey-100 mt-1">
        🤩 Bonus: Experience how HOGC is aligned and mobilised in the engine room of the church -
        Leaders' meeting! No signup required.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BonusLeadersMeeting',
};
</script>
